var _g, _g2, _g3, _g4, _g5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "95.383,0 1.244,94.139 20.06,112.955 69.217,63.8 90.71,85.293 41.554,134.449 60.37,153.265 109.526,104.11  131.019,125.603 81.863,174.758 100.68,193.575 149.836,144.419 171.329,165.913 122.173,215.068 140.989,233.884  235.129,139.745  "
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "372.255,276.871 278.116,371.011 296.932,389.827 346.087,340.671 367.58,362.164 318.425,411.32  337.242,430.137 386.397,380.981 407.89,402.474 358.735,451.63 377.551,470.446 426.706,421.29 448.2,442.783 399.044,491.94  417.861,510.756 512,416.617  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "347.234,70.627 53.388,364.472 41.989,395.973 36.604,410.852 101.148,475.396 116.027,470.011 147.528,458.612  441.373,164.766  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M492.136,19.864c-25.954-25.955-68.184-25.955-94.139,0l-29.27,29.27l94.139,94.139l29.27-29.27 C518.09,88.049,518.09,45.818,492.136,19.864z"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "25.182,442.416 0,512 69.584,486.818  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.141f6c849b0ff7ede38518f758e1b9d3.svg";
export { ForwardRef as ReactComponent };